import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-preload-list-data',
  templateUrl: './preload-list-data.component.html',
  styleUrls: ['./preload-list-data.component.css'],
})
export class PreloadListDataComponent extends BaseListCtl {
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);
    let _self = this;
    locator.getPathVariable(route, function (params: any) {
      _self.form.searchParams['listId'] = params.getKey('id');
    });
    _self.locator.config
      .getProperty('endpoint.preloadlistdata')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
  }

  public parentList = [];

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.label = data.label;
    form.data = data.data;
    form.status = data.status;
    form.listId = data.listId;
    form.listName = data.listName;
    form.listCode = data.listCode;
    form.fieldId = data.fieldId;
    form.fieldValue = data.fieldValue;
    form.parentList = [];
    form.parentName = 'No Parent';
    this.getParentList(data.listId);
  }

  /**
   * get parent list data
   */
  getParentList(listId: any) {
    let _self = this;
    _self.form['parentList'] = [];
    var url = this.api.endpoint + '/parentlistdata/' + listId;
    this.locator.http.get(url, function (res: any, error: any) {
      if (error) {
        return;
      }
      if (res.success) {
        _self.form['parentList'] = res.result.data;
        _self.form['parentName'] = res.result.parentName;
      }
    });
  }

  addListData() {
    this.get(0);
    if (this.form.searchParams['listId']) {
      this.form.data['listId'] = this.form.searchParams['listId'];
      this.getParentList(this.form.data['listId']);
    }
  }

  searchByField(val: any) {
    this.form.searchParams['fieldValue'] = val;
    this.search();
  }
}
